import { Box, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";


function ShareModal(props) {

    const handleCopyLink = () => {
        let field = document.querySelector(".copy-link-container");
        let input = document.querySelector(".copy-input");
        let copy = document.querySelector(".copy-btn");
        console.log("input",input)
        input.select(); //select input value
        if (document.execCommand("copy")) { //if the selected text is copied
            field.classList.add("active");
            copy.innerText = "کپی شد";
            setTimeout(() => {
                window.getSelection().removeAllRanges(); //remove selection from page
                field.classList.remove("active");
                copy.innerText = "کپی";
            }, 3000);
        }
    }
    
    return (
        <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "100%" }}>
            <div style={{ color: "#000" }}>
                اشتراک گذاری لینک به وسیله :
            </div>
            <ul className="share-list">
                <li>
                    <a href={`https://telegram.me/share/msg?url=${props?.link}&text=${encodeURIComponent(props.textToShare.trim())}`} target="blank">
                        <img src="/assets/img/telegram.png" />
                    </a>
                </li>
                <li>
                    <a href={`mailto:?body=${props?.link}&subject=${encodeURIComponent(props.textToShare.trim())}`}>
                        <img src="/assets/img/gmail.png" width="50px" />
                    </a>
                </li>
                <li>
                    <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(props.textToShare.trim())} ${props?.link}`} target="blank">
                        <img src="/assets/img/whatsapp.png" width="50px" />
                    </a>
                </li>
            </ul>
            <p>یا کپی لینک :</p>
            <div style={{ border: "1px solid", borderRadius: "5px", padding: "5px", display: "flex" }} className="copy-link-container">
                <input type="text" value={props?.link} readOnly className='flex-1 copy-input border-0' />
                <Button onClick={handleCopyLink} className="copy-btn" sx={{ bgcolor: "#029e9d!important", color: "#fff" }}>کپی</Button>
            </div>
        </Box>
    );
}

export default ShareModal;